import { Box, Checkbox, Typography } from '@mui/material';
import { useState } from 'react';

import { CardWithContent } from '@/components/molecules/card-with-content';

interface Props {
  destinationId: number;
  destinationName: string;
  isSelected: boolean;
  toggleSelection: (checked: boolean, id: number) => void;
}

const DestinationCard = ({
  destinationId,
  destinationName,
  isSelected,
  toggleSelection,
}: Props) => {
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(true);

  return (
    <CardWithContent
      isSelected={isSelected}
      onClick={() => {
        setIsCheckboxChecked(prevIsCheckboxSelected => !prevIsCheckboxSelected);
        toggleSelection(isCheckboxChecked, destinationId);
      }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Checkbox
          checked={isSelected}
          onChange={e => {
            toggleSelection(e.target.checked, destinationId);
          }}
        />
        <Typography variant="body2">{destinationName}</Typography>
      </Box>
    </CardWithContent>
  );
};

export default DestinationCard;
